import { Link } from 'react-router-dom';

const INK   = '#0d0d0d';
const BLUE  = '#1755f4';
const MUTED = '#9ca3af';
const BORDER = '#e8e8e8';
const FONT  = "'Helvetica Neue', Helvetica, Arial, sans-serif";

/* ── Pre-built SVG icons ── */
export function IconBuilding() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="0"/><path d="M9 3v18M15 3v18M3 9h18M3 15h18"/>
    </svg>
  );
}
export function IconUsers() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  );
}
export function IconDocument() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
      <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
    </svg>
  );
}
export function IconCash() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="7" width="20" height="14" rx="0"/>
      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
      <circle cx="12" cy="14" r="2"/>
    </svg>
  );
}
export function IconChart() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/>
    </svg>
  );
}
export function IconBell() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
    </svg>
  );
}
export function IconShield() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );
}
export function IconCheck() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
  );
}

/* ── EmptyState component ── */
export default function EmptyState({ icon, title, description, action, onAction, actionHref }) {
  return (
    <div style={{
      padding: '80px 32px',
      textAlign: 'center',
      border: `1px solid ${BORDER}`,
      background: 'white',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      fontFamily: FONT,
    }}>
      {icon && (
        <div style={{
          width: '72px', height: '72px', background: '#f9fafb', border: `1px solid ${BORDER}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#d1d5db', marginBottom: '24px',
        }}>
          {icon}
        </div>
      )}
      <div style={{
        fontSize: '18px', fontWeight: 800, color: INK,
        marginBottom: description ? '10px' : (action ? '28px' : 0),
        letterSpacing: '-0.4px', maxWidth: '360px',
      }}>
        {title}
      </div>
      {description && (
        <div style={{
          fontSize: '13px', color: MUTED, lineHeight: 1.7,
          maxWidth: '320px', marginBottom: action ? '28px' : 0,
        }}>
          {description}
        </div>
      )}
      {action && (
        actionHref ? (
          <Link to={actionHref} style={{
            display: 'inline-flex', alignItems: 'center', gap: '8px',
            background: INK, color: 'white', textDecoration: 'none',
            padding: '13px 28px', fontSize: '12px', fontWeight: 700,
            letterSpacing: '0.3px', fontFamily: FONT,
            transition: 'background 0.15s',
          }}>
            {action}
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
            </svg>
          </Link>
        ) : (
          <button onClick={onAction} style={{
            display: 'inline-flex', alignItems: 'center', gap: '8px',
            background: INK, color: 'white', border: 'none',
            padding: '13px 28px', fontSize: '12px', fontWeight: 700,
            letterSpacing: '0.3px', cursor: 'pointer',
            fontFamily: FONT, transition: 'background 0.15s',
          }}>
            {action}
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
            </svg>
          </button>
        )
      )}
    </div>
  );
}
